import { render, staticRenderFns } from "./PropTableString.vue?vue&type=template&id=5335b7ad&"
import script from "./PropTableString.vue?vue&type=script&lang=js&"
export * from "./PropTableString.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports